/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Status_ResolvedInputs */

const en_us2_bodymap_status_resolved = /** @type {(inputs: Bodymap_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fully recovered`)
};

const pt_br2_bodymap_status_resolved = /** @type {(inputs: Bodymap_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalmente recuperado`)
};

const es_419_bodymap_status_resolved = /** @type {(inputs: Bodymap_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalmente recuperado`)
};

const pt_pt2_bodymap_status_resolved = /** @type {(inputs: Bodymap_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalmente recuperado`)
};

const fr_fr2_bodymap_status_resolved = /** @type {(inputs: Bodymap_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guérison complète`)
};

const de_de2_bodymap_status_resolved = /** @type {(inputs: Bodymap_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständig erholt`)
};

const it_it2_bodymap_status_resolved = /** @type {(inputs: Bodymap_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero completo`)
};

/**
* | output |
* | --- |
* | "Fully recovered" |
*
* @param {Bodymap_Status_ResolvedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_status_resolved = /** @type {((inputs?: Bodymap_Status_ResolvedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Status_ResolvedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_status_resolved(inputs)
	if (locale === "es-419") return es_419_bodymap_status_resolved(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_status_resolved(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_status_resolved(inputs)
	if (locale === "de-DE") return de_de2_bodymap_status_resolved(inputs)
	if (locale === "it-IT") return it_it2_bodymap_status_resolved(inputs)
	return en_us2_bodymap_status_resolved(inputs)
});
export { bodymap_status_resolved as "bodymap.status.resolved" }